module.exports = __webpack_public_path__ + "static/img/icon_money.facd4c05.png";